module.exports = __webpack_public_path__ + "static/media/racecheck_logo_black.9cfd65a7.svg";